export default __webpack_public_path__ + "2e02dd46f6e88286bee1ec7bfe7795ea.svg";